module.exports = __webpack_public_path__ + "GreenBlob_HealthSystems___2Hv4u.svg";